import { BUSINESS_TYPE_LABELS, type LocalDto } from '@gl/shared';
import { Check, ChevronsUpDown, Plus } from 'lucide-react';
import { useNavigate } from 'react-router';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useLocalsQuery } from '@/lib/locals';
import { cn } from '@/lib/utils';

export function LocalAvatar({ local, className }: { local: Pick<LocalDto, 'name' | 'logoUrl' | 'primaryColor'>; className?: string }) {
  if (local.logoUrl) {
    return <img src={local.logoUrl} alt="" className={cn('size-8 shrink-0 rounded-md object-cover', className)} />;
  }
  return (
    <span
      className={cn('flex size-8 shrink-0 items-center justify-center rounded-md text-sm font-semibold text-white', className)}
      style={{ backgroundColor: local.primaryColor }}
    >
      {local.name.slice(0, 1).toUpperCase()}
    </span>
  );
}

export function LocalSwitcher({ current, className }: { current: LocalDto; className?: string }) {
  const navigate = useNavigate();
  const { data: locals = [] } = useLocalsQuery();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={cn(
          'flex w-full min-w-0 items-center gap-2 rounded-lg p-1.5 text-left outline-none hover:bg-accent focus-visible:ring-[3px] focus-visible:ring-ring/50',
          className,
        )}
      >
        <LocalAvatar local={current} />
        <span className="min-w-0 flex-1">
          <span className="block truncate text-sm font-semibold">{current.name}</span>
          <span className="block truncate text-xs text-muted-foreground">
            {current.isDemo ? 'Demo' : BUSINESS_TYPE_LABELS[current.businessType]}
          </span>
        </span>
        <ChevronsUpDown className="size-4 shrink-0 text-muted-foreground" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuLabel className="text-xs text-muted-foreground">Tus locales</DropdownMenuLabel>
        {locals.map((l) => (
          <DropdownMenuItem key={l.id} onSelect={() => navigate(`/l/${l.id}/resumen`)}>
            <LocalAvatar local={l} className="size-6 text-xs" />
            <span className="flex-1 truncate">{l.name}</span>
            {l.id === current.id && <Check className="size-4" />}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => navigate('/onboarding')}>
          <Plus /> Crear otro local
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
